import { Component, Element, Host, Method, Prop, h } from '@stencil/core';

@Component({
  tag: 'sy-blog-content',
  styleUrl: './scss/index.scss',
  scoped: true,
})
export class SyBlogContent {
  @Element() host: HTMLSyBlogContentElement;

  /**
   * Recive the innerHTML content
   */
  @Prop() content: string;

  /**
   * If has a fixed navbar on the page, you can define this heigth to put the right value on scrool
   */
  @Prop() headerHeight: string;

  /**
   * Navigates to a specific text section
   */
  @Method()
  async navigateToSection(sectionId: string): Promise<void> {
    const section = this.host.querySelector(`#${sectionId}`) as HTMLElement;
    section.scrollIntoView({
      behavior: 'smooth',
    });
  }

  render() {
    return (
      <Host>
        <div innerHTML={this.content}></div>
      </Host>
    );
  }
}
